/* eslint-disable no-console, quotes, consistent-return */
import type { User as DatadogUser } from "@datadog/browser-core"
import { datadogLogs } from "@datadog/browser-logs"
import { type RumEvent, datadogRum } from "@datadog/browser-rum"

import type { IUserModel } from "@/3514/types"
import { JS_CONF } from "@/constants"

const botPatterns = "[pP]ingdom"

const botRegex = new RegExp(botPatterns, "i")

const isPingdomBot: boolean = botRegex.test(navigator.userAgent)

function initDatadog(): void {
    if (!isPingdomBot) {
        datadogRum.init({
            applicationId: JS_CONF.datadog_application_id,
            clientToken: JS_CONF.datadog_client_token,
            site: JS_CONF.datadog_site,
            service: JS_CONF.datadog_service,
            env: JS_CONF.datadog_env,
            sessionReplaySampleRate: 100,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            defaultPrivacyLevel: "mask-user-input",
            version: JSAPP_CONF?.version ?? "",
            beforeSend(event: RumEvent): false {
                if (
                    event.type === "action" &&
                    event.action?.type === "click" &&
                    (event.action?.target?.selector as string)?.includes('[data-rum-ignore="true"]')
                ) {
                    return false
                }
            }
        })

        datadogLogs.init({
            clientToken: JS_CONF.datadog_client_token,
            site: JS_CONF.datadog_site,
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
            forwardConsoleLogs: "all",
            forwardReports: "all"
        })

        datadogRum.startSessionReplayRecording()

        console.log("\x1b[95m%s\x1b[0m", "Datadog session started")
    }
}

function setDatadogUser(user: IUserModel, extra?: object): void {
    const userData: DatadogUser = {
        id: String(user.id),
        userId: String(user.userId),
        name: `${user.firstName} ${user.lastName}`,
        email: user.email,
        version: JSAPP_CONF.version ?? String(""),
        ...extra
    }

    datadogRum.setUser(userData)
    datadogLogs.setUser(userData)

    console.log("\x1b[95m%s\x1b[0m", "Datadog session user set")
}

function fireActionDatadog(actionName: string, actionContext: object = {}): void {
    datadogRum.addAction(actionName, { ...actionContext })

    console.log("\x1b[95m%s\x1b[0m", "Datadog action sent")
}

export { initDatadog, setDatadogUser, fireActionDatadog }
